export const supplyTables = [{
        id: 1,
        type: 'tables',
        name: 'Birch Table',
        description: 'Dining table in a trending taupe reclaimed wood-look finish with thick, block-style legs to keep everything in its place during your large gatherings. The robust panel construction of the taupe reclaimed look table top makes for the perfect farmhouse dining table. Sit comfortably at this kitchen table that seats up to 4 people. Chairs are sold separately.',
        description_short: '',
        price: '100',
        cardColor: 'rgb(231, 180, 255)',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421131_10_FRONT.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421131_20_DETAIL.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421131_90_DECOR.png'
    }, {
        id: 2,
        type: 'tables',
        name: 'Hard Wood Table',
        description: 'A standard high quality table usually placed on the front porch, The quality of wood allows the table to withstand the elements but it still needs to be looked after.',
        description_short: '',
        price: '80',
        cardColor: 'lightYellow',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00410046_30_ANGLE30.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00410046_40_ANGLE90.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00410046_20_FRONTPANEL.png'
    },
    {
        id: 3,
        type: 'tables',
        name: 'Dark Wood Table',
        description: 'A luxurious stylish and sleek table used in dining halls and for prestigious events, this is a beautiful well made table that will stick with you for life, granted you take care of it.',
        description_short: '',
        price: '300',
        cardColor: 'lightPink',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00387518_30_ANGLE30.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00387518_20_FRONTPANEL.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00387518_10_FRONT.png'
    }, {
        id: 4,
        type: 'tables',
        name: 'Tempered Glass Table',
        description: 'Bring a stylish touch to your kitchen room with this contemporary tempered glass end table, sure to be a classy and tasteful complement any interior.',
        description_short: '',
        price: '125',
        cardColor: 'lightBlue',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00305403_20_ANGLE30.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00305403_10_FRONT.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00305403_30_ANGLE90.png'
    }, {
        id: 5,
        type: 'tables',
        name: 'Grey Ceramic Table',
        description: 'A table specifically designed and developed with new ceramic cutting edge table that offers exceptional style and great functionality for every day use, this specific table comes with a surprise.',
        description_short: '',
        price: '50',
        cardColor: 'lightGreen',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00408606_30_ANGLE30.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00408606_40_ANGLE90.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00408606_74_MECANISM.png'
    }, {
        id: 6,
        type: 'tables',
        name: 'White Table',
        description: 'A standard table that gets the job done but not in a stylish manner, this table can hold a lot of weight but don\'t over do it because the table is not very strong.',
        description_short: '',
        price: '40',
        cardColor: 'rgb(248, 158, 158)',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421114_10_FRONT.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421114_20_DETAIL.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421114_90_DECOR.png'
    }, {
        id: 7,
        type: 'tables',
        name: 'Jungle Wood Table',
        description: 'A exotic table that is made for the homes with great interior design, it might not be a good fit for your dining room but if you plan the room around the style and make of the table then the room will be changed into a exotic chamber, this table will have to be imported so if ordered it might take a while to get to you',
        description_short: '',
        price: '100',
        cardColor: 'rgb(204, 142, 255)',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00407519_20_ANGLE30.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00407519_-10_FRONT.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00407519_90_DECOR.png'
    }, {
        id: 8,
        type: 'tables',
        name: 'Hybrid Table',
        description: 'A table that has the best of both world it has the sturdiness of a metal table with the style of a birch wood table but a lot more modernized, if you want to customize it drawers and cuts styles can make it so that your table will be the only one of its kind in the world.',
        description_short: '',
        price: '200',
        cardColor: 'rgb(142, 210, 255)',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421124_10_FRONT.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421124_20_DETAIL.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421124_90_DECOR.png'
    }
]

//arr of objects where you will use the index of the object in the array as the url route param to target the specific object

export const supplyCabinets = [{
        id: 1,
        type: 'cabinets',
        name: 'Acacia Wood Cabinet',
        description: 'The mix of acacia wood and metal is a beautiful match. This 7 drawers dresser is the best of modern and rustic style. It will charm you for sure.',
        description_short: '',
        price: '100',
        cardColor: 'rgb(231, 180, 255)',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00372322_20_ANGLE30.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00372322_10_FRONT.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/small/00372322_21_ANGLE30.png'
    },
    {
        id: 2,
        type: 'cabinets',
        name: 'Hard Brown Wood Cabinet',
        description: 'Of a transitional taste, combining the sleek lines of modern design with a rustic finish, this 6-drawer dresser offers a timeless look that will be at home in many incarnations of your décor.',
        description_short: '',
        price: '80',
        cardColor: 'lightYellow',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00426795_20_ANGLE30.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00426795_10_FRONT.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00426795_21_ANGLE90.png'
    },
    {
        id: 3,
        type: 'cabinets',
        name: 'Dark Wood Cabinet',
        description: 'With a simple and classical design, this dark grey drawer chest with a versatile look elegantly matches a wide number of décors. It highlights the decorative elements that surround it.',
        description_short: '',
        price: '150',
        cardColor: 'lightPink',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00408948_20_ANGLE30.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00408948_10_FRONT.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00408948_21_ANGLE30.png'
    },
    {
        id: 4,
        type: 'cabinets',
        name: 'Unique Wood Cabinet',
        description: 'Patchwork of disparate colours, textures and patterns, this surprising accent cabinet with a distressed finish embodies the spirit of the BoHo Chic movement. It is exquisitely audacious, down to its mismatched handles.',
        description_short: 'Customizable Cabinet',
        price: '95',
        cardColor: 'lightBlue',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00399530_20_ANGLE30.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00399530_10_FRONT.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00399530_21_ANGLE30.png'
    },
    {
        id: 5,
        type: 'cabinets',
        name: 'White Cabinet',
        description: 'Give your teen\'s bedroom a facelift with this low - profile chest. Great for storing your favorite clothes and belongings!',
        description_short: '',
        price: '50',
        cardColor: 'lightGreen',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00283873_20_ANGLE30.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00283873_10_FRONT.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00283873_21_ANGLE30.png'
    },
    {
        id: 6,
        type: 'cabinets',
        name: 'Dark Grey Cabinet With Mirror',
        description: 'Archetype of a successful transitional design, this dresser with mirror walks the line between the rustic and the contemporary. Its versatile look ties together the decorative influences from the past and the present in your décor.',
        description_short: '',
        price: '40',
        cardColor: 'rgb(248, 158, 158)',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00406840_20_ANGLE30.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00406840_10_FRONT.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00406840_50_DETAIL.png'
    },
    {
        id: 7,
        type: 'cabinets',
        name: 'Jungle Wood Large Cabinet',
        description: 'With a sober and simple rustic style, this 6 drawers dresser harmoniously matches a transitional interior, combining contemporary and traditional stylistic elements, or a country-inspired interior, overflowing with lace and flowers.',
        description_short: '',
        price: '100',
        cardColor: 'rgb(204, 142, 255)',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00365376_20_ANGLE30.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00365376_10_FRONT.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00365376_21_ANGLE30.png'
    },
    {
        id: 8,
        type: 'cabinets',
        name: 'Hybrid Colour Cabinet',
        description: 'Multiplying its influences, with sleek lines that are no stranger to the Bauhaus movement and asymmetrical Mid-Century inspired oblique legs, this 2-drawer dresser combines the best of design to give you an incomparable contemporary elegance.',
        description_short: '',
        price: '200',
        cardColor: 'rgb(142, 210, 255)',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00423612_20_ANGLE30.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00423612_10_FRONT.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00423612_21_ANGLE30.png'
    }
];


export const supplyDecor = [{
        id: 1,
        type: 'room_decor',
        name: 'Black Console Table',
        description: 'Spacious and thick paneled three-tier design for added display space. Console table features a modern straight-lined rectangular shape. Can be used as an entryway table or accent table',
        description_short: '',
        price: '35',
        cardColor: 'rgb(231, 180, 255)',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421440_10_FRONT.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421440_20_DETAIL.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421440_90_DECOR.png'
    }, {
        id: 2,
        type: 'room_decor',
        name: 'Kitchen Trolley',
        description: 'Elegant simplicity and functionality: this deep brown modern lined trolley adds refinement and storage to a contemporary kitchen.',
        description_short: '',
        price: '20',
        cardColor: 'lightYellow',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00288870_20_ANGLE30.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00288870_10_FRONT.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00288870_21_ANGLE30.png'
    },
    {
        id: 3,
        type: 'room_decor',
        name: 'Multicolored Carpet',
        description: 'Designed like a lively abstract painting, this colourful rug projects a contagious joy. It capture attention and creates a surprising style contrast in an uncluttered interior.',
        description_short: '',
        price: '70',
        cardColor: 'lightPink',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00411530_10_FRONT.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00411530_30_DETAIL.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00411530_50_DECOR.png'
    }, {
        id: 4,
        type: 'room_decor',
        name: 'Ivory Hanging Chair',
        description: 'Woven with large meshes, this hanging chair will fit in with a soothing BoHo interior or balcony. Perfectly suited for the reading corner, it projects an aura of tranquility in the décor.',
        description_short: '',
        price: '95',
        cardColor: 'lightBlue',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00424079_20_ANGLE30.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00424079_10_FRONT.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00424079_30_DETAIL.png'
    }, {
        id: 5,
        type: 'room_decor',
        name: 'White Ottoman',
        description: 'Ottoman in a fun cube shape and upholstered in a white leather-look fabric. Biscuit tufted and comfortably padded on all sides. Small poufs look like contemporary furniture for grownups but are sized specifically for children',
        description_short: '',
        price: '50',
        cardColor: 'lightGreen',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421540_10_FRONT.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421540_20_DETAIL.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421540_90_DECOR.png'
    },
    {
        id: 6,
        type: 'room_decor',
        name: 'Beige and Brown Carpet',
        description: 'Warm and inviting, brown and beige inspire calm and well-being. With its delicate wavy lines, this rug is the final touch to a serene interior.',
        description_short: '',
        price: '40',
        cardColor: 'rgb(248, 158, 158)',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00378497_10_FRONT.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00378497_30_DETAIL.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00378497_50_DECOR.png'
    },
    {
        id: 7,
        type: 'room_decor',
        name: 'Dark Brown Wine Shelf',
        description: 'With 2 door cabinet style closed storage, this wine shelf is equipped with a suspended stem glass holder with a fixed shelf. Wine storage for up to 15 bottles.',
        description_short: '',
        price: '100',
        cardColor: 'rgb(204, 142, 255)',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421060_10_FRONT.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421060_20_DETAIL.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421060_90_DECOR.png'
    }, {
        id: 8,
        type: 'room_decor',
        name: 'Grey Hybrid Wall Shelf',
        description: 'Industrial chic-inspired, this contemporary design wall shelf matches a reconditioned warehouse style loft. Functional or decorative, it welcomes your books as well as your decorative items.',
        description_short: '',
        price: '200',
        cardColor: 'rgb(142, 210, 255)',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00413247_20_ANGLE30.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00413247_10_FRONT.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00413247_30_ANGLE90.png'
    }
];


export const supplyChairs = [{
        id: 1,
        type: 'chairs',
        name: 'Beige Chair',
        description: 'This chair\'s timeless styling in solid wood and beige fabric will be perfect in any dining room.Its rungs give it even more solidity.',
        description_short: '',
        price: '100',
        cardColor: 'rgb(231, 180, 255)',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00336738_20_ANGLE30.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00336738_20_ANGLE30.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00336738_40_BACK.png'
    }, {
        id: 2,
        type: 'chairs',
        name: 'Beige Couch Chair',
        description: 'Dining chair with integrated armrests. Upholstered in a taupe distressed leather-look fabric with a cushioned seat and padded back for comfort and support. Tapered metal legs in a black finish.',
        description_short: '',
        price: '80',
        cardColor: 'lightYellow',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421040_10_FRONT.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421040_20_DETAIL.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421040_90_DECOR.png'
    },
    {
        id: 3,
        type: 'chairs',
        name: 'Dark Wood Chair',
        description: 'Warm espresso finish with a cushioned beige fabric seat. Comfortable high back for support with an open slat design.',
        description_short: '',
        price: '150',
        cardColor: 'lightPink',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421034_10_FRONT.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421034_20_DETAIL.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421034_90_DECOR.png'
    }, {
        id: 4,
        type: 'chairs',
        name: 'Grey Metal Chair',
        description: 'Dining room chair in a grey leather look material. Supported by a solid matching grey metal base, this kitchen chair is upholstered in a smooth easy-to-clean material. This faux leather modern dining chair slides perfectly under most tables to save space in small homes, apartments or condos.',
        description_short: '',
        price: '95',
        cardColor: 'lightBlue',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421023_10_FRONT.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421023_20_DETAIL.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421023_90_DECOR.png'
    }, {
        id: 5,
        type: 'chairs',
        name: 'White Chair',
        description: 'Dining room chair in a white leather-look material. Supported by a solid matching white metal base, this kitchen chair is upholstered in a smooth easy-to-clean material. This faux leather modern dining chair slides perfectly under most tables to save space in small homes, apartments or condos.',
        description_short: '',
        price: '50',
        cardColor: 'lightGreen',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421018_10_FRONT.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421018_20_DETAIL.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00421018_90_DECOR.png'
    }, {
        id: 6,
        type: 'chairs',
        name: 'Black Business Chair',
        description: 'Supported by a solid U-shaped chrome metal base, this kitchen chair is upholstered in a black velvet look fabric with two vertical rows of stitching for added elegance. This dining room chair boasts a cushioned seat to allow you to dine in comfort.',
        description_short: '',
        price: '40',
        cardColor: 'rgb(248, 158, 158)',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00356162_20_ANGLE30.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00356162_10_FRONT.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00356162_30_ANGLE90.png'
    }, {
        id: 7,
        type: 'chairs',
        name: 'Red Leather Chair',
        description: 'Vibrant and elegant, red is a fascinating colour, made for interior design. Matched with the purposeful curves of a retro modern chair, it bring a bold contemporary charm to a stylish interior.',
        description_short: '',
        price: '100',
        cardColor: 'rgb(204, 142, 255)',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00391450_20_ANGLE30.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00391450_10_FRONT.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00391450_40_BACK.png'
    }, {
        id: 8,
        type: 'chairs',
        name: 'Green Couch',
        description: 'With a retro-modern look borrowing both the Mid-Century and Art Deco trends, this unique turquoise sofa contributes to the charm of a bold interior, where eclectic influences and colors meet.',
        description_short: '',
        price: '200',
        cardColor: 'rgb(142, 210, 255)',
        image: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00426629_20_ANGLE30.png',
        image2: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00426629_10_FRONT.png',
        image3: 'https://www.braultetmartineau.com/INTERSHOP/static/WFS/BMTC-BraultMartineau-Site/-/BMTC/en_CA/large/00426629_60_BACK.png'
    }
];

export default { supplyChairs, supplyCabinets, supplyTables, supplyDecor }